<template>
    <div class="body" ref="body">

        <div v-if="showModal" class="custom-popup">
             <div class="m-dialog">
                <div class="modal-header">{{ $t("message.sponsor_created") }}</div>
                <div class="m-content">
                    <center><b>ID : {{registredAccount.id}}</b></center>
                </div>
                <div class="modal-footer">
                    <button @click="showss()" class="btn btn-info" type="button">{{ $t("message.close") }}
                    </button>
                </div>

            
            </div>
        </div>

        <div v-if="loading" class="">
            <div v-for="i in 5" class="row" style="margin-top: 30px" :key="i">
                <div class="col-1"></div>
                <div class="col-2"><v-skeleton-loader
                        type="text"
                ></v-skeleton-loader></div>
                <div class="col-9"><v-skeleton-loader
                        type="heading"
                ></v-skeleton-loader></div>
            </div>
            <div class="row" style="margin-top: 50px">
                <div class="col-4"></div>
                <div class="col-2"><v-skeleton-loader style="float: right"
                                                      type="chip"
                ></v-skeleton-loader></div>
                <div class="col-2"><v-skeleton-loader
                        type="chip"
                ></v-skeleton-loader></div>
                <div class="col-4"></div>
            </div>
        </div>
        <div v-else class="container-fluid">
            <div id="page-title" v-if="false">
                <h2>{{ $t("message.register_new_member") }}</h2>
                <p>{{ $t("message.title_comment") }}</p>
            </div>
            <div class="panel">
                <div class="panel-body">
                    <div class="example-box-wrapper"></div>
                    <form class="form-horizontal bordered-row" @submit="onSubmit" @reset="onReset" v-if="formShow">
                        <div class="form-group" v-for="(oneCol,index) in allParams" :key="oneCol.id"
                             v-bind:class="`${index === 0 ?  'remove-border' : ''}`">
                            <div class="row">
                                <label class="col-sm-5 col-md-3 control-label">{{oneCol.title}}<span v-if="oneCol.isMandatory"
                                                                                                     style="color: red"> *</span></label>
                                <div class="col-sm-6 col-md-6">
                                    <input class="form-control" v-bind:id="`lf-${oneCol.id}`" v-if="'email'===oneCol.alias"
                                           type="email" v-bind:placeholder="$t('message.enter') + ' '+ oneCol.title"
                                           v-model="oneCol.value" v-bind:required="oneCol.isMandatory"/>


                                    <vue-tel-input mode="international"
                                        v-else-if="'phone'===oneCol.alias"
                                        style="height: 32px;background-color: #FFF;"
                                        :dropdownOptions="{ showFlags: true, showDialCodeInSelection: true, }"
                                        valid-characters-only="true"
                                        autoformat
                                        v-bind:id="`lf-${oneCol.id}`"
                                        required="true"
                                        v-model="oneCol.value"
                                        min="5"
                                    ></vue-tel-input>

                                    <b-form-select v-bind:style="oneCol.value==null? 'color:#999' : 'color:#333'"
                                                   v-bind:id="`lf-${oneCol.id}`" v-else-if="'country_id'===oneCol.alias"
                                                   class="form-control" v-model="oneCol.value"
                                                   v-bind:required="oneCol.isMandatory" @change="currentRegion.value = null">
                                        <option :value="null">{{$t('message.select') + ' '+ oneCol.title}}</option>
                                        <option v-for="oneCR in countryRegionList" :value="oneCR" :key="oneCR.id">
                                            {{oneCR.title}}
                                        </option>
                                    </b-form-select>
                                    <b-form-select
                                            :disabled="currentCountry.value && currentCountry.value.regions && currentCountry.value.regions.length? false : true"
                                            v-bind:style="oneCol.value==null? 'color:#999' : 'color:#333'"
                                            v-bind:id="`lf-${oneCol.id}`" v-else-if="'region_id'===oneCol.alias"
                                            class="form-control" v-model="oneCol.value"
                                            v-bind:required="oneCol.isMandatory">
                                        <option :value="null">{{$t('message.select') + ' '+ oneCol.title}}</option>
                                        <option v-for="oneR in (currentCountry.value ? currentCountry.value.regions : [])"
                                                :value="oneR" :key="oneR.id">{{oneR.title}}
                                        </option>
                                    </b-form-select>
                                    <div class="input-group bootstrap-touchspin" v-else-if="'numeric'===oneCol.fieldType.alias">
                                <span class="input-group-addon bootstrap-touchspin-prefix"
                                      style="display: none;"></span>
                                        <input v-bind:id="`lf-${oneCol.id}`" class="form-control" @keypress="isNumber"
                                               maxlength="20" v-bind:required="oneCol.isMandatory"
                                               type="text" v-bind:name="`nm-${oneCol.id}`" v-model="oneCol.value"
                                               v-bind:placeholder="$t('message.enter') + ' '+ oneCol.title"
                                               style="display: block;border-radius: 3px"><span
                                            class="input-group-addon bootstrap-touchspin-postfix" style="display: none;"></span><span
                                            class="input-group-btn-vertical"><button
                                            class="btn btn-default bootstrap-touchspin-up" type="button"
                                            @click="!isNaN(oneCol.value) ? oneCol.value++ : oneCol.value=0"><font-awesome-icon
                                            style="height: 10px;position: absolute;left: 11px;top: 3px;" icon="plus"/></button><button
                                            class="btn btn-default bootstrap-touchspin-down" type="button"
                                            @click="!isNaN(oneCol.value)&&oneCol.value>0 ? oneCol.value--:oneCol.value=0"><font-awesome-icon
                                            icon="minus" style="height: 10px;position: absolute;left: 11px;top: 3px;"/></button></span>
                                    </div>
                                    <div v-else-if="'date'===oneCol.fieldType.alias" class="input-prepend input-group">
                                    <span class="add-on input-group-addon">
                                        <font-awesome-icon
                                                icon="calendar-alt" style="height: 16px;"/>
                                    </span>
                                        <input type="date" class="form-control" v-bind:required="oneCol.isMandatory"
                                               v-model="oneCol.value"
                                               v-bind:id="`lf-${oneCol.id}`">
                                    </div>
                                    <div v-else-if="['float','currency'].includes(oneCol.fieldType.alias)"
                                         class="input-group bootstrap-touchspin"><span class="input-group-btn"><button
                                            class="btn btn-default bootstrap-touchspin-down"
                                            type="button"
                                            @click="!isNaN(oneCol.value)&&oneCol.value>0 ? oneCol.value=(oneCol.value-1).toFixed(8):oneCol.value=0"><font-awesome-icon
                                            style="height: 11px" icon="minus"/></button></span><span
                                            class="input-group-addon bootstrap-touchspin-prefix"
                                            style="display: none;"></span><input class="form-control" v-bind:required="oneCol.isMandatory"
                                                                                 v-bind:id="`lf-${oneCol.id}`"
                                                                                 v-bind:placeholder="$t('message.enter') + ' '+ oneCol.title"
                                                                                 pattern="\d+(\.\d{1,})?"
                                                                                 type="text" v-model="oneCol.value"
                                                                                 @keydown="processInputFloat"
                                                                                 style="display: block;"><span
                                            class="input-group-btn"><button class="btn btn-default bootstrap-touchspin-up"
                                                                            type="button"
                                                                            @click="!isNaN(oneCol.value) ? oneCol.value=(Number(oneCol.value) + 1).toFixed(8) : oneCol.value=0"><font-awesome-icon
                                            style="height: 11px" icon="plus"/></button></span></div>
                                    <b-form-select v-bind:style="oneCol.value==null? 'color:#999' : 'color:#333'"
                                                   v-bind:id="`lf-${oneCol.id}`"
                                                   v-else-if="'dictionary'===oneCol.fieldType.alias"
                                                   class="form-control" v-model="oneCol.value"
                                                   v-bind:required="oneCol.isMandatory">
                                        <option :value="null">{{$t('message.select') + ' '+ oneCol.title}}</option>
                                        <option v-for="oneCR in oneCol.dictionary.items" :value="oneCR.key" :key="oneCR.key">
                                            {{oneCR.value}}
                                        </option>
                                    </b-form-select>
                                    <input class="form-control" v-bind:id="`lf-${oneCol.id}`"
                                           v-else type="text"
                                           v-bind:placeholder="$t('message.enter') + ' '+ oneCol.title"
                                           v-model="oneCol.value" v-bind:required="oneCol.isMandatory"/>

                                </div>
                            </div>

                        </div>
                        <template v-if="registrationMethod">
                            <div class="form-group">
                                <label class="col-sm-5 col-md-3 control-label" for="password1_reg">{{$t('message.password')}}</label>
                                <div class="button-inside col-sm-6 col-md-6">
                                    <input class="form-control" id="password1_reg" v-model="password1"
                                           :type="showPass1 ? 'text' : 'password'" required
                                           :minlength="passwordLength||6">
                                    <div class="button-pass" @click.prevent="showPass1=!showPass1">
                                        <font-awesome-icon :icon="showPass1 ? 'eye' : 'eye-slash'"
                                                           class="faw"/>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-5 col-md-3 control-label" for="password2_reg">{{$t('message.password_confirm')}}</label>
                                <div class="button-inside col-sm-6 col-md-6">
                                    <input class="form-control" id="password2_reg" v-model="password2"
                                           :type="showPass2 ? 'text' : 'password'" required
                                           :minlength="passwordLength||6"
                                           v-bind:style="((p1L>(passwordLength-1||5)) && (password1===password2)) ? {'border-color': 'green'}: ((p2L>(passwordLength-1||5)) ? {'border-color': 'red'} : {}) ">
                                    <div class="button-pass" @click.prevent="showPass2=!showPass2">
                                        <font-awesome-icon :icon="showPass2 ? 'eye' : 'eye-slash'"
                                                           class="faw"/>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div class="button-pane mrg20T">
                            <button class="btn btn-primary" :disabled="loadingToServer || (password1!==password2 && p1L>(passwordLength-1||5) && p2L>(passwordLength-1||5))"><span v-if="loadingToServer"
                                                                                              class="loading"></span>{{
                                $t("message.submit") }}
                            </button>
                            <button class="btn btn-link font-gray-dark" type="reset" :disabled="loadingToServer">{{
                                $t("message.clear") }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {VSkeletonLoader} from 'vuetify/lib'
    import {BFormSelect} from 'bootstrap-vue'
    import VueTelInput from 'vue-tel-input'
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
    import {faPlus, faMinus, faCalendarAlt, faEye, faEyeSlash} from '@fortawesome/free-solid-svg-icons' //icon-cog, icon-envelope-o,icon-unlock-alt
    import Layer0 from '../../extend_classes/Layer0';
    library.add(faPlus, faMinus, faCalendarAlt, faEye, faEyeSlash);
    window.Vue.use(VueTelInput)
    const i18n = new window.VueI18n({
        locale: 'en-US', // set locale
        fallbackLocale: 'en-US',
        messages: {
            "en-US": {
                "message": {
                    "register_new_member": "Register new member",
                    "title_comment": "Sign up new frontline member",
                    "submit": "Submit",
                    "clear": "Clear",
                    "select": "Please select",
                    "enter": "Enter",
                    "password": "Password",
                    "password_confirm": "Confirm password",
                    "please_check": "Please check email to registration complete",
                    "email_validation": "Email value is an invalid"
                }
            }
        }

    });
    const keyCodes = {
        windows: {
            "backspace": 8,
            "tab": 9,
            "enter": 13,
            "left arrow": 37,
            "right arrow": 39,
            "delete": 46,
            "period": 190,
            "0": 48,
            "9": 57,
            "num 0": 96,
            "num 9": 105,
            "num period": 110,
            "input busy": 229
        }
    };
    export default {
        name: 'register-member',
        i18n: i18n,
        extends: Layer0,
        components: {
            VSkeletonLoader,
            BFormSelect,
            FontAwesomeIcon,
        },
        props: {
            passwordLength: {
                default: 6,
                required: false,
                type: Number
            },
            showingFields: {
                default: '[]',
                required: false,
                type: String

            },
            accountId: {
                required: false,
                type: Number

            },
            ...Layer0.props
        },
        data: function () {
            return {
                country_and_regionRequired: false,
                password1: '',
                password2: '',
                registredAccount: { id: 0},
                showModal: false,
                mailPattern: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[a-z]{2,4}$/,
                showPass1: false,
                showPass2: false,
                registrationMethod: 0,
                loadingToServer: false,
                currentCountry: null,
                currentRegion: null,
                errResp: null,
                allParams: null,
                formShow: true,
                countryRegionList: [],
                loc_name: 'VRegisterMember'
            }
        },
        computed: {
            p1L() {
                return this.password1.length;
            },
            p2L() {
                return this.password2.length;
            }
        },
        methods: {
            showss(){
                this.showModal = !this.showModal;
            },
            processInputFloat(e) {
                let pressedKey = e.which,
                    point = e.target.value.indexOf("."),
                    keys = keyCodes.windows;

                // HACK for Chrome on Android (doesn't seem to work, though)
                if (pressedKey === keys["input busy"]) {
                    e.preventDefault();
                    return;
                }

                let allowedKeys = [
                    keys["backspace"],
                    keys["tab"],
                    keys["enter"],
                    keys["left arrow"],
                    keys["right arrow"],
                    keys["delete"],
                    keys["period"],
                    keys["num period"]
                ];

                // Decimal point already in value
                if (point !== -1) {
                    allowedKeys.splice(allowedKeys.indexOf(keys["period"]), 1);
                    allowedKeys.splice(allowedKeys.indexOf(keys["num period"]), 1);

                    if (e.target.value.length > (point + 8) && this.selectionStart === this.selectionEnd &&
                        (!allowedKeys.includes(pressedKey))) {
                        // Allow only 2 decimal places, allow whitelisted keys after 2 decimal places reached
                        e.preventDefault();
                        return;
                    }
                }

                if ((pressedKey < keys["0"] || pressedKey > keys["9"]) &&
                    (pressedKey < keys["num 0"] || pressedKey > keys["num 9"]) &&
                    (!allowedKeys.includes(pressedKey))) {
                    // Allow only whitelisted (non-numeric) keys
                    e.preventDefault();
                }
            },
            isNumber(evt) {
                evt = (evt) ? evt : window.event;
                let charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && charCode < 48) || charCode > 57)
                    evt.preventDefault();

            },
            generatePassword() {
              const length = this.passwordLength
              const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
              let retVal = ""
              for (let i = 0, n = charset.length; i < length; ++i) {
                retVal += charset.charAt(Math.floor(Math.random() * n));
              }
              return retVal;
            },
            async onSubmit(evt) {
                evt.preventDefault();
                this.loadingToServer = true;
                let loginParam = "", typeParam = "member";
                let profileFields = {};
                this.allParams.forEach(v => {
                    if (v.alias === "email")
                        loginParam = v.value;
                    if (!v.value)
                        return true;
                    if (["country_id", "region_id"].includes(v.alias) && v.value.id) {
                        profileFields[v.alias] = v.value.id;
                        return true;
                    }
                    profileFields[v.alias] = v.value;
                });
                let aid = this.accountId;
                if (!aid)
                    aid = await this.store.dispatch('getAccountId');
                if (this.country_and_regionRequired) {
                    profileFields['country_and_region']=this.currentCountry.value.id+'/'+this.currentRegion.value.id;
                }

                let tempPass = this.generatePassword()

                if (profileFields?.email && !new RegExp(this.mailPattern).test(profileFields.email)) {
                    this.store.dispatch('showToast', {
                        title: '',
                        body: this.$t('message.email_validation'),
                        type: 'error',
                        timeout: 7000
                    });
                    this.loadingToServer = false;
                    return true;
                }

                let checkParams = {
                    "email": profileFields.email,
                    "phone": profileFields.phone,
                }

                let uniqArrayRes = {}
                let otpError = null;

                uniqArrayRes = await this.store.dispatch('reqApi', {
                    path: '/account/uniqueness-check',
                    method: 'post',
                    params_: checkParams,
                    withoutCheckLogin: true
                    }).then((response) => {

                    if (response?.success === false) {
                        if (response?.error?.fields?.email) {
                            otpError = response.error.fields.email[0]
                        } else if (response?.error?.fields?.phone) {
                            otpError = response.error.fields.phone[0]
                        }
                        
                        this.store.dispatch('showToast', {
                            title: '',
                            body: otpError || 'something went wrong',
                            type: 'error',
                            timeout: 7000
                        });
                    }

                    return response
                })

                if (otpError != null) {
                    this.loadingToServer = false;
                    return
                }

                let uniqueErr = 0

                if(profileFields?.phone?.length > 0) {
                    if(!uniqArrayRes.data?.payload?.phoneUnique) {
                        this.store.dispatch('showToast', {
                            title: '',
                            body: this.$t('message.not_unique_phone'),
                            type: 'error',
                            timeout: 7000
                        });
                        uniqueErr = 1
                    }
                }
                if(profileFields?.email?.length > 0) {
                    if(!uniqArrayRes.data?.payload?.emailUnique) {
                        this.store.dispatch('showToast', {
                            title: '',
                            body: this.$t('message.not_unique_email'),
                            type: 'error',
                            timeout: 7000
                        });
                        uniqueErr = 1
                    }
                }

                if(uniqueErr === 1) {
                    this.loadingToServer = false;
                    return
                }

                await this.store.dispatch('requestApi3', {
                    path: '/account/create',
                    method: 'post',
                    params_: {
                        "login": loginParam,
                        "type": typeParam,
                        "sponsorId": Number(aid),
                        "password": this.registrationMethod === 1 ? this.password1 : tempPass,
                        "profile": profileFields,
                        "confirmationUrl": window.location.protocol + "//" + window.location.host + "/?email_code_confirm={{code}}"
                    }
                }).then((response) => {
                    this.loadingToServer = false;

                    console.log('response', response)

                    if(response?.data?.success === true) {
                        this.registredAccount = response?.data?.payload?.info?.account || '0'
                        this.showModal        = true;
                        this.password1        = '';
                        this.password2        = '';
                        this.store.dispatch('showToast', {
                            title: '',
                            body: this.$t('message.please_check'),
                            type: 'success'
                        });
                    } else {
                        this.store.dispatch('showToast', {
                            title: '',
                            body: response?.error?.description || response?.data?.error?.description,
                            type: 'error',
                            timeout: 7000
                        });
                    }

                }).catch((e) => {
                    console.log('e_', e)
                    if (e.error) {
                        this.store.dispatch('showToast', {
                            title: '',
                            body: e.error.description,
                            type: 'error'
                        });
                    } else {
                        this.store.dispatch('showToast', {
                            title: '',
                            body: 'Something went wrong',
                            type: 'error'
                        });
                    }
                    this.loadingToServer = false;
                })
            },
            onReset(evt) {
                evt.preventDefault();
                /* Reset our form values */
                this.allParams.forEach(v => {
                    v.value = null;
                });
                this.password1 = '';
                this.password2 = '';
                /* Trick to reset/clear native browser form validation state */
                this.formShow = false;
                this.$nextTick(() => {
                    this.formShow = true
                });
            },
            getInfo() {
                if (!this.loading)
                    this.loading = true;
                let at;
                try {
                    at = JSON.parse(this.showingFields);
                    if (!Array.isArray(at))
                        at = [];
                }
                catch (e) {
                    at = [];
                }
                if (at.includes('region_id') && !at.includes('country_id'))
                    at.push('country_id');
                const HTTPGlobalSettings = this.store.dispatch('request', {
                    path: 'api2/main-app/setting/get-list?group=global',
                    method: 'get',
                    withoutCheckLogin: true
                });
                HTTPGlobalSettings.then(response => {
                    if (response.data.errorCode === 0) {
                        this.registrationMethod = response['data']['primary']['payload']['settings']['passwordCreationType'];
                    }
                    else
                        this.registrationMethod = 0;
                }).catch(function () {
                        this.registrationMethod = 0;
                    }
                );
                const HTTP = this.store.dispatch('request', {
                    path: 'api2/main-app/profile-field/get-list',
                    method: 'get'
                });
                HTTP.then(response => {
                    if (response !== 'loading') {
                        if (response.data.errorCode === 0) {
                            this.allParams = (response['data']['primary']['payload']['list'].map(v => {
                                if (v.fieldType.alias === 'dictionary') {
                                    v.value = null;
                                    v.dictionary.items.sort((a, b) => {
                                        return a.priority != null && (b.priority == null || a.priority < b.priority) ? -1 : b.priority != null && (a.priority == null || a.priority > b.priority) ? 1 : 0;
                                    });
                                    return v;
                                }
                                if (['country_id', 'region_id'].includes(v.alias)) {
                                    if (v.isMandatory)
                                        this.country_and_regionRequired = true;
                                    v.value = null;
                                    if ('country_id' === v.alias)
                                        this.currentCountry = v;
                                    else
                                        this.currentRegion = v;
                                }
                                else
                                    v.value = "";
                                return v;
                            }));
                            if (at.includes('country_id') || this.country_and_regionRequired) {
                                const isRegionAllowed = (at.includes('region_id') || this.country_and_regionRequired)? 1 : 0;
                                this.store.dispatch('request', {
                                    path: 'api2/main-app/country/get-list?withRegions=' + isRegionAllowed,
                                    method: 'get'
                                }).then(response => {
                                    if (response !== 'loading') {
                                        if (response.data.errorCode === 0) {
                                            this.countryRegionList = response['data']['primary']['payload']['list'];
                                        }
                                    }
                                }).catch(e => {
                                    throw e;
                                });
                            }

                            console.log('this.allParams before', JSON.stringify(this.allParams))
                            this.allParams = this.allParams.filter(value => {
                                return value.alias!=='country_and_region' && (value.isMandatory || at.includes(value.alias))
                            });
                            this.allParams.sort((a, b) => {
                                return ((at.indexOf(a.alias) < 0 && at.indexOf(b.alias) >= 0) || (at.indexOf(a.alias) > at.indexOf(b.alias))) ? 1 : (at.indexOf(a.alias) < at.indexOf(b.alias)) ? -1 : 0;
                            });
                            this.loading = false;
                        }
                    }
                }).catch(() => {
                    this.loading = false;
                });
            }
        }
    }
</script>
<style scoped>

.custom-popup{
    position: absolute;
    min-width: 500px;
    height: 200px;
    background-color: #FFF;
    top: 200px;
    margin: auto;
    left: 25%;
    font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
    z-index: 100;
    border: 0;
    box-shadow: 0 15px 45px rgba(0,0,0,.3);
    border-radius: 6px;
    transition: 3s;
}

.custom-popup .m-dialog {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: space-between;
    height: 100%;
    padding: 0px;
    margin: 0px;
}

.custom-popup .m-dialog .m-content{
    padding: 15px
}

.custom-popup .m-dialog .modal-header{
    min-height: 16.42857143px;
    padding: 15px;
    border-bottom: 1px solid #dfe8f1;
}
    @import '~vuetify/dist/vuetify.min.css';
    @import './../../styles/projectStyles/vuetify/vuetify-del.css';
    @import '~bootstrap-vue/dist/bootstrap-vue.min.css';
    @import '~bootstrap/dist/css/bootstrap.min.css';
    @import "./../../styles/monarch/themes/admin/color-schemes/default.css";
    @import "./../../styles/monarch/elements/buttons.css";
    @import "./../../styles/monarch/themes/components/default.css";
    @import "./../../styles/monarch/elements/forms.css";
    @import "./../../styles/monarch/helpers/boilerplate.css";
    @import "./../../styles/monarch/helpers/utils.css";
    @import "./../../styles/monarch/helpers/typography.css";
    @import "./../../styles/monarch/helpers/grid.css";
    @import "./../../styles/monarch/widgets/touchspin/touchspin.css";
    @import './../../styles/projectStyles/vue-tel-input.css';
    @import "./assets/register-member.css";
</style>
